import { Injectable } from '@angular/core';
import {Program, SiteTopology, TopologyObject} from "../domain/cloud-topology";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable()
export class SideNavService  {

  siteTopology: SiteTopology[];
  developers: TopologyObject[] = [];
  accounts: TopologyObject[] = [];
  sites: TopologyObject[] = [];
  private siteTopologyCache: BehaviorSubject<SiteTopology[]>;
  private programCache: BehaviorSubject<Program[]>;
  constructor() {
    this.clear();
  }

  private clear(): void {
    this.siteTopologyCache = new BehaviorSubject<SiteTopology[]>(null);
    this.programCache = new BehaviorSubject<Program[]>(null);
  }

  setSiteTopology(sites: SiteTopology[]): void {
    this.siteTopology = this.sortAlphabetically(sites);
    this.siteTopologyCache.next(sites);

    this.setDevelopers();
    this.setAccounts();
  }

  setProgramsCache(programs: Program[]): void {
    this.programCache.next(this.sortAlphabetically(programs));
  }

  getSiteTopology(): SiteTopology[] {
    return this.siteTopology;
  }

  getAccounts(): TopologyObject[] {
    return this.accounts;
  }

  getAccountsForDeveloper(developerId: string): TopologyObject[] {
    if (this.accounts) {
      return this.accounts.filter((topologyObj) => {
        return topologyObj.parentId == developerId;
      });
    }

    return null;
  }

  getSitesForAccount(accountId: string): TopologyObject[] {
    const siteTopology =  this.siteTopology.filter((topologyObj) => {
      return topologyObj.accountId == accountId;
    });

    let topologyObjects: TopologyObject[] = [];
    for (const site of siteTopology) {
      topologyObjects.push({
        name: site.name,
        id: site.id,
        parentId: site.accountId
      });
    }

    return topologyObjects;
  }

  getDevelopers(): TopologyObject[] {
    return this.developers;
  }

  getSiteCache(): Observable<SiteTopology[]> {
    return this.siteTopologyCache.asObservable();
  }

  getProgramCache(): Observable<Program[]> {
    return this.programCache.asObservable();
  }

  private setDevelopers(): TopologyObject[] {
    if (this.developers.length == 0) {
      for (const site of this.siteTopology) {
        if (!this.developers.find((developer) => {
          return developer.id === site.developerId;
        })) {
          this.developers.push({
            id: site.developerId,
            name: site.developerName,
            parentId: null
          });
        }
      }
      this.developers = this.sortAlphabetically(this.developers);
    }

    return this.developers;
  }

  private setAccounts() {
    if(this.accounts.length == 0) {
      for (const site of this.siteTopology) {
        if (!this.accounts.find((account) => {
          return account.id === site.accountId;
        })) {
          this.accounts.push({
            id: site.accountId,
            name: site.accountName,
            parentId: site.developerId,
          });
        }
      }
    }

    return this.accounts;
  }

  private sortAlphabetically(obj: any): any[] {
    return obj.sort((a, b) => {
      const aName = a.accountName?.toLowerCase() ?? a.name.toLowerCase();
      const bName = b.accountName?.toLowerCase() ?? b.name.toLowerCase();
      return aName < bName ? -1 : 1;
    });
  }
}
